import general from '../../general.js'

var input = function (params) {
	return {
		init: function () {
			var wrapper = params.wrapper
			var inputType = params.type
			this.elementName = params.name
			var required = params.required
			var pattern = params.pattern
			var valueToPrefill = params.valueToPrefill
			var placeholder = params.placeholder
			var disabled = params.disabled
			var description = params.description
			const entity = params.entity
			this.options = params.options
			let elementPropID = null
			if (this.options) {
				elementPropID = this.options.element[1].property.id
			}

			var input = document.createElement('input')
			input.setAttribute('type', inputType)
			input.setAttribute('name', this.elementName)
			if (pattern) input.setAttribute('pattern', pattern)
			if (required) input.setAttribute('required', required)
			if (valueToPrefill) input.value = valueToPrefill
			if (placeholder) input.setAttribute('placeholder', placeholder)
			if (disabled) input.setAttribute('disabled', 'true')

			wrapper.appendChild(input)

			if (description) {
				var desc = document.createElement('div')
				desc.setAttribute('class', 'description')
				desc.innerHTML = description
				wrapper.appendChild(desc)
			}

			if (elementPropID) this.listenToChangesForSlugCreation(input, elementPropID, entity)

			// add class for slug fields
			const slugStr = '.slug.'
			if (this.elementName.indexOf(slugStr) > 0) {
				input.classList.add('slug-field')

				// add error message
				var errorMessage = document.createElement('div')
				errorMessage.setAttribute('class', 'field-error-message')
				errorMessage.innerHTML = 'This URL already exists. Please modify it in order to create a unique URL.'
				wrapper.appendChild(errorMessage)
			}
		},

		listenToChangesForSlugCreation: function (input, elementPropID, entity) {
			let referenceDisplayProp = null
			if (entity.settings) {
				if (entity.settings.addressable) {
					if (entity.settings.addressable.value === 'true') {
						if (entity.settings.referenceDisplayProperty) {
							referenceDisplayProp = entity.settings.referenceDisplayProperty.value

							if (elementPropID == referenceDisplayProp) {
								// listen to changes in this field and output a slugified version in the slug field
								input.addEventListener('input', this.inputHandler.bind(this))
							}
						}
					}
				}
			}
		},

		inputHandler: function (e) {
			const target = e.currentTarget
			const value = target.value
			const url = general.convertToSlug(value)

			// find slug field
			const urlFielfName = this.elementName.replace(this.options.element[0], 'slug')
			const urlField = document.querySelector('input[name="' + urlFielfName + '"]')
			if (urlField) urlField.value = url
		}
	}
}

export default input
